// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import ElementUI from 'element-ui'
import '@/assets/css/common.scss'
import store from '@/store'
import App from './App'
import api from '@/api/index'
import warn from '@/pages/error/userError'
// import sentry from './utils/sentry'
import './tracer'
import utils from './utils/utilsplugin';
// Vue.use(sentry)
Vue.use(ElementUI)
Vue.use(utils)

Vue.prototype.$loading = ElementUI.Loading.service
Vue.prototype.$msgbox = ElementUI.MessageBox
Vue.prototype.$alert = ElementUI.MessageBox.alert
Vue.prototype.$confirm = ElementUI.MessageBox.confirm
Vue.prototype.$prompt = ElementUI.MessageBox.prompt
Vue.prototype.$notify = ElementUI.Notification
Vue.prototype.$message = ElementUI.Message
Vue.prototype.$EventBus = new Vue() // 增加事件总线,用于一些特殊情况下的页面及组件间通信
Vue.prototype.$error = err => {
  var errData
  var errCont = (err.error || {}).error || {}
  // Vue.$logger.setUserContext(store.getters.loginSupplier)
  if (err.from && err.ret !== undefined) { // 区分接口报错
    if (errCont.code > 10000) {
      return
    }
    // 只上报code小于10000的接口报错
    // errData = `接口报错:${JSON.stringify(err)}`
    // Vue.$logger.captureException(errData)
  } else { // 非接口报错
    errData = err
    // Vue.$logger.captureException(errData)
  }
  // 开发环境 抛出接口错误 预警
  if (process.env.NODE_ENV === 'development') {
    console.warn(errData)
  }

  if (err.from) {
    if (errCont.code < 10000 && errCont.msg) {
      return ElementUI.Message(errCont.msg)
    }
    if (errCont.code >= 10000) {
      location.href = '/sweb/login/loginOut'
    }
  }
}

Vue.config.productionTip = false

// let instance1 = new Vue({
//   el: '#app',
//   store,
//   router,
//   components: { App },
//   template: '<App/>'
// })
// console.log(instance1)
/* eslint-disable no-new */

const p = (method, param) => new Promise((resolve) => {
  method(Object.assign({}, param)).then(res => resolve(res.data)).catch(e => resolve([]))
})
let p1 = p(api.getUserInfo)
let p2 = p(api.getEmbedUrls)

Promise.all([p1, p2]).then(res => {
  let loginUser = res[0]
  let hostMap = res[1]
  if (loginUser.ret === 1 && loginUser.data && hostMap.ret === 1 && hostMap.data) {
    if(loginUser.data.loginStatus === 0) {
      window.location.href = '/sweb/login/loginOut'
    } else {
      // window.__punch.to(
      //   `${loginUser.data.name} ${loginUser.data.passportPhone}`, // 水印内容
      //   {
      //     width: 250,
      //     height: 80,
      //     bg: 'transparent',
      //     bgAlpha: 1,
      //     color: '#ebebeb',
      //     alpha: 0.8,
      //     font: '14px Arial'
      //   }
      // )
      store.commit('setLoginSupplier', loginUser.data)
      store.commit('swebPublic/setHostMap', hostMap.data)

      api.listSupplierClass().then((res) => {
        const classes = res.data.data.filter(({ id }) => id).map(({name}) => name).join(',')
        store.commit('setLoginSupplier', { ...loginUser.data, classes })
      }).catch(() => {
      })
    }
    return Promise.resolve(loginUser, hostMap)
  } else {
    window.location.href = '/sweb/login/loginOut'

    // debugger
    // if (error) {
    //   return Promise.reject({ from: 'getUserInfoOrGetEmbedUrls', error })
    // }
    // window.location.href = '/sweb/login/loginOut'
  }
}).then((loginUser, hostMap) => {

  if (!loginUser || loginUser.data.loginStatus === 0) {
    window.location.href = '/sweb/login/loginOut'
    return
  }
  let resData = loginUser.data
  let instance = new Vue({
    el: '#app',
    store,
    router,
    components: { App },
    template: '<App/>'
  })

  let { id = 0, cityId = 0, passportId = 0 } = resData
  instance.$tracer.updateParam({
    uid: id,
    passport_id: passportId,
    city_id: cityId
  })
  if (resData.loginStatus === 1) { // "passport已登录，未选择供应商，跳转选择页面"
    router.push({name: 'selectSupplier'})
  } else if(resData.loginStatus === 3) { // "passport已登录，已选择框架主体，跳转框架主体页面"
    router.push({path: location.hash ? location.hash.slice(1) : '/frameAgreement'})
  } else { // "passport已登录，已选择供应商，跳转当前供应商页面"
    if (!location.hash) {
      router.push({name: 'main'})
    }
  }
}).catch(err => {
  console.log('err', err)
  if (err.from) {
    if ((err.error.code < 10000 || err.error.code > 20000) && err.error.msg) {
      new Vue({
        el: '#app',
        data: {
          err: err.error.msg
        },
        components: {warn},
        template: '<warn :warnInfo="err"/>'
      })
    } else {
      window.location.href = '/sweb/login/loginOut'
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js